import { mode } from '@chakra-ui/theme-tools';
export const buttonStyles = {
  components: {
    Button: {
      baseStyle: {
        borderRadius: '18px',
        boxShadow: 'none',
        transition: 'all .22s ease',
        boxSizing: 'border-box',
        fontWeight: '700',
        letterSpacing: '-0.02em',
        _focus: {
          boxShadow: '0 0 0 4px rgba(111, 66, 193, 0.16)',
        },
        _active: {
          boxShadow: 'none',
        },
      },
      variants: {
        outline: () => ({
          borderRadius: '18px',
          borderWidth: '1px',
        }),
        brand: (props) => ({
          bg: mode('brand.500', 'brand.400')(props),
          color: 'white',
          boxShadow: mode(
            '0 16px 34px rgba(111, 66, 193, 0.28)',
            '0 16px 34px rgba(174, 134, 242, 0.22)',
          )(props),
          _focus: {
            bg: mode('brand.500', 'brand.400')(props),
          },
          _active: {
            bg: mode('brand.600', 'brand.300')(props),
            transform: 'translateY(1px)',
          },
          _hover: {
            bg: mode('brand.600', 'brand.300')(props),
            transform: 'translateY(-1px)',
          },
        }),
        darkBrand: (props) => ({
          bg: mode('brand.900', 'brand.400')(props),
          color: 'white',
          _focus: {
            bg: mode('brand.900', 'brand.400')(props),
          },
          _active: {
            bg: mode('brand.900', 'brand.400')(props),
          },
          _hover: {
            bg: mode('brand.800', 'brand.400')(props),
          },
        }),
        lightBrand: (props) => ({
          bg: mode('rgba(111, 66, 193, 0.08)', 'whiteAlpha.100')(props),
          color: mode('brand.500', 'white')(props),
          _focus: {
            bg: mode('#F2EFFF', 'whiteAlpha.100')(props),
          },
          _active: {
            bg: mode('secondaryGray.300', 'whiteAlpha.100')(props),
          },
          _hover: {
            bg: mode('secondaryGray.400', 'whiteAlpha.200')(props),
          },
        }),
        light: (props) => ({
          bg: mode('rgba(255,255,255,0.74)', 'rgba(255,255,255,0.06)')(props),
          color: mode('secondaryGray.900', 'white')(props),
          _focus: {
            bg: mode('secondaryGray.300', 'whiteAlpha.100')(props),
          },
          _active: {
            bg: mode('secondaryGray.300', 'whiteAlpha.100')(props),
          },
          _hover: {
            bg: mode('secondaryGray.400', 'whiteAlpha.200')(props),
          },
        }),
        action: (props) => ({
          fontWeight: '700',
          borderRadius: '50px',
          bg: mode('rgba(111, 66, 193, 0.08)', 'brand.400')(props),
          color: mode('brand.500', 'white')(props),
          _focus: {
            bg: mode('secondaryGray.300', 'brand.400')(props),
          },
          _active: { bg: mode('secondaryGray.300', 'brand.400')(props) },
          _hover: {
            bg: mode('secondaryGray.200', 'brand.400')(props),
          },
        }),
        setup: (props) => ({
          fontWeight: '700',
          borderRadius: '50px',
          bg: mode('transparent', 'brand.400')(props),
          border: mode('1px solid', '0px solid')(props),
          borderColor: mode('secondaryGray.400', 'transparent')(props),
          color: mode('secondaryGray.900', 'white')(props),
          _focus: {
            bg: mode('transparent', 'brand.400')(props),
          },
          _active: { bg: mode('transparent', 'brand.400')(props) },
          _hover: {
            bg: mode('secondaryGray.100', 'brand.400')(props),
          },
        }),
        subtle: (props) => ({
          bg: mode('rgba(255,255,255,0.65)', 'rgba(255,255,255,0.06)')(props),
          color: mode('secondaryGray.900', 'white')(props),
          border: '1px solid',
          borderColor: mode(
            'rgba(162, 176, 210, 0.18)',
            'rgba(255,255,255,0.08)',
          )(props),
          _hover: {
            bg: mode('white', 'rgba(255,255,255,0.1)')(props),
          },
        }),
        'no-hover': {
          _hover: { bg: 'transparent' },
          _active: { bg: 'transparent' },
        },
      },
    },
  },
};
